import React, { useContext, createContext, useState,useReducer } from "react";
// import { useDispatch } from 'react-redux';
import { Route } from "react-router-dom";
import { users, conference } from "@/api";
import {getAllBroadcastNumberRules} from "@/api/virtualRule";
import * as consts from "@/config/const";
import { AnyType, UserInfo } from "@/types";

import { storage } from "@/util";
import { debug } from "console";
import {Action,reducer, initialState} from "../../Action"
// import { Logger } from './Logger';

// interface LoginInfo {
//   password:string,
//   username:string,
//   conferenceNo:string,
//   muteJoinMeeting:boolean,
//   allowEarlyEntry:boolean,
//   ownerPassword:string,
//   ownerPasswordEnable:boolean,
//   passwordEnable:boolean,
// }
interface AuthContext {
  loggedIn?: boolean;
  login?: (params: any, cb: () => void) => void;
  logout?: (cb: () => void) => void;
  // loginfo?: LoginInfo;
  // loginfo?:UserInfo;
  loginfo?: AnyType;
  updateLogInfo?: (p: AnyType) => void;
}

export const authContext = createContext<AuthContext>({});

export const useAuth = () => {
  return useContext(authContext);
};

export const ProvideAuth = (props: any) => {
  const auth = useProvideAuth();
  return (
    <authContext.Provider value={auth}>{props.children}</authContext.Provider>
  );
};
function findMostSimilar(input: string, arr: string[]): string {
  let maxSimilarity = 0;
  let mostSimilar = '';

  const calculateSimilarity = (str1: string, str2: string): number => {
      let similarity = 0;
      for (let i = 0; i < Math.min(str1.length, str2.length); i++) {
          if (str1[i] === str2[i]) {
              similarity++;
          }
      }
      return similarity;
  };

  for (const element of arr) {
      const similarity = calculateSimilarity(input, element);
      if (similarity > maxSimilarity) {
          maxSimilarity = similarity;
          mostSimilar = element;
      }
  }

  return mostSimilar;
}
// 获取预约会议列表里面的是否入会提示音

export const useProvideAuth = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const token = window.localStorage.getItem(consts.LOGINTOKEN);
  const [loggedIn, setLoggedIn] = useState(!!token);
  const [loginfo, setLoginfo] = React.useState<AnyType>({});

  const getYuyueMeetList =async () =>{
    const paramsb = {
      pageNum: 0,
      pageSize: 1000,
      param: {},
    };
    const ret = await conference.orderList(paramsb);
    // dispatch(  { type: 'SetOrderList', payload: ret });
    
  }
  const login = async (params: any, cb: () => void) => {
    const ret = await users.oauthToken({
      ...params,
      grant_type: "password",
      client_id: "client_id",
      client_secret: "client_secret",
      support_new_token: false,
    });
    const { accessToken } = ret;
    storage.save(consts.LOGINTOKEN, accessToken);
    dispatch(  { type: 'SetAccessToken', payload: accessToken });
    setLoggedIn(true);
    const infos: UserInfo = (await users.getUserInfo()) as UserInfo;
    console.log("当前登陆用户的虚拟号：",infos.virtualNum)
    
    
    // getYuyueMeetList();
    // getRuleList();
    setLoginfo(infos);
    storage.save(consts.LOGININFOSTORE, infos);
    cb();

    
    // const prepareToCallList:string[] = [];
    // try {  
    //   ;
    //   const rules: any = await getAllBroadcastNumberRules();
      
    //   if(rules && rules.data && rules.data.length > 0){
        
    //     rules.data.forEach((item: any) => {
    //        const rule_ = item.number;
    //        console.log("rule_:",rule_);
    //        prepareToCallList.push(rule_);
           
    //       //  ['999#', '888?', '666#', '777*', '988#']
    //    });
    //    console.log("获取所有组播号码规则:",prepareToCallList );
    //    localStorage.setItem("prepareToCallList",JSON.stringify(rules.data));
    //    const  mostSimilarRule = findMostSimilar(infos.virtualNum, prepareToCallList)
    //    console.log("最相似的规则:",mostSimilarRule); 
    //   } else {
    //      console.log("没有查询到组播虚拟号规则数据");
    //   }
      
    // } 
    // catch (error) {
    //   console.log("获取所有组播号码规则失败:",error);
    // }
    
  };

  const aginfo = async () => {
    const ainfos: UserInfo = (await users.getUserInfo()) as UserInfo;
    setLoginfo(ainfos);
  };

  if (token && !loginfo.userId) {
    aginfo();
  }
 
   const logout = (cb: () => void) => {
    // 调用登出接口
    // ...
    // 存储登录状态
    storage.remove(consts.LOGININFOSTORE);
    storage.remove(consts.LOGINTOKEN);
    setLoggedIn(false);
    cb();
  };

  const updateLogInfo = (info: AnyType) => {
    setLoginfo({ ...loginfo, ...info });
    setLoggedIn(true);
  };

  return {
    loggedIn,
    login,
    logout,
    loginfo,
    updateLogInfo,
  };
};

// 先把这个界面的登录要求去掉
export const PrivateRoute = (props: any) => {
  const { children, ...rest } = props;
  // let auth = useAuth();
  return (
    <Route
      {...rest}
      render={() => children}
      // render={({ location }) =>
      //   auth.loggedIn ? (
      //     children
      //   ) : (
      //     <Redirect
      //       to={{
      //         pathname: "/login",
      //         state: { from: location },
      //       }}
      //     />
      //   )
      // }
    />
  );
};
